const BaseView = require('components-framework/view/base.view');
const trackingUtils = require('../../../../webapp/static-content/_versionedByRelease_/js/modules/utils/tracking.utils');
const DRAWER_TRACKING_ACTION = 'ancillary_information';
const DYNPACK_PRODUCT = 'dp';
const FLIGHTS_PRODUCT = 'fl';
const PAGES_TO_TRACK = {
    results: 'res',
    details: 'pax',
    flightsummary: 'sum',
    flightinfo: 'info',
    payment: 'pay',
};

const getFlowStep = () => {
    const page = Odigeo.History.getPageNameFromFragment();
    const productPageIdentifier = getProductPageIdentifier();
    return PAGES_TO_TRACK[page] + productPageIdentifier;
};

const getProductPageIdentifier = () => {
    return Odigeo.Utils.isRequestApp(DYNPACK_PRODUCT) ? DYNPACK_PRODUCT : FLIGHTS_PRODUCT;
};

const getCoverBlockKeys = (keys) => {
    return [
        {
            title: keys.coverProvidedTitle,
            items: [
                keys.coverProvidedItem1,
                keys.coverProvidedItem2,
                keys.coverProvidedItem3,
                keys.coverProvidedItem4,
            ],
            description: keys.coverProvidedDescription,
        },
        {
            title: keys.coverNOTProvidedTitle,
            items: [
                keys.coverNOTProvidedItem1,
                keys.coverNOTProvidedItem2,
                keys.coverNOTProvidedItem3,
                keys.coverNOTProvidedItem4,
            ],
        },
    ];
};

const insertCoverBlocks = ({insuranceCoverBlock, insuranceCoverItem, insuranceCoverBlockDescription}, keys) => {
    const insuranceCoverBlockKeys = getCoverBlockKeys(keys);
    return insuranceCoverBlockKeys.map((block) => {
        const {items, description, title} = block;
        const options = {
            items,
            description,
            title,
            insuranceCoverBlock,
            insuranceCoverItem,
            insuranceCoverBlockDescription};
        return insertCoverBlock(options);
    }).join('');
};

const insertCoverBlock = ({items, description, title, insuranceCoverBlock, insuranceCoverItem, insuranceCoverBlockDescription}) => {
    const list = items.map((item) => addCoverProvidedItem(item, insuranceCoverItem)).join('');
    const coverDescription = insertCoverBlockDescription(description, insuranceCoverBlockDescription);
    return insuranceCoverBlock({title, list, description: coverDescription});
};

const insertCoverBlockDescription = (description, insuranceCoverBlockDescription) => {
    return description ? insuranceCoverBlockDescription({description}) : '';
};

const addCoverProvidedItem = (item, insuranceCoverItem) => {
    return item ? insuranceCoverItem({item}) : '';
};

module.exports = BaseView.extend({
    drawer: {},
    events: {
        'click .terms_and_conditions_link': 'trackClickPDFLink',
    },
    initialize() {
        this.options.template = this.templates.main;
        this.options.keys = this.keys;
        this.render(this.options);
    },

    render({keys, template}) {
        const items = insertCoverBlocks(this.templates, this.keys);
        const data = {
            keys,
            items,
        };
        this.$el.html(template(data));
    },

    trackClickPDFLink: () => {
        const step = getFlowStep();
        const label = `ancillary_open_conditions_footer_cat:HUB_pag:${step}`;
        trackingUtils.trackEvent(DRAWER_TRACKING_ACTION, label);
    },
});
